import React from 'react';
import {connect} from 'react-redux';
import {PropTypes} from 'prop-types';

import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from '../../Inputs/DatePicker';

import {forgotPassword} from '../../../Actions/Password/forgot';

class ForgotPassword extends React.Component {
    state = {
        error: false,
        success: false,
        email: '',
        dob: '',
        startDate: null,
    };

    processPassword = (e) => {
        e.preventDefault();
        if (this.state.email && this.state.dob) {
            const data = {
                email: this.state.email,
                dob: this.state.dob.format('YYYY-MM-DD'),

            };
            this.props.dispatch(forgotPassword(data));
            this.setState({success: 'True'});
        } else {
            this.setState({error: 'Fields Required'});
        }
    };

    render() {
        return (
            <div className="wrap reset-password">
                <fieldset>
                    {this.state.success ? (
                        <div>
                            <h1 className="h2 justifycentre">Password Reset</h1>
                            <p className="justifycentre">
                                If you have an account with us you will shortly receive an email with instructions on
                                resetting your password.
                            </p>
                            <p className="justifycentre">
                                If you do not receive an email or experience any issues please feel free to <a
                                href="/contact/request-a-callback/">contact us</a>.
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={this.processPassword} className="form-register">
                            <div>
                                <h1 className="h2 justifycentre">Reset your password</h1>
                                <p className="justifycentre">
                                    To reset your password please enter your email address and data of birth below.
                                    <br/>
                                    If you have an account with us you will receive an email with instructions on how to
                                    reset your password.
                                    <br/>
                                    <br/>
                                </p>
                            </div>
                            {this.state.error ? (
                                <div className="form-register_question">
                                    <p className="alert-error justifycentre">{this.state.error}</p>
                                </div>
                            ) : null}
                            <div className="form-register_question">
                                <label>
                                    Email
                                    <input name="email" type="email" required
                                           onChange={e => this.setState({email: e.target.value})}/>
                                </label>
                            </div>
                            <div className="form-register_question">
                                <label>
                                    Date of Birth</label>
                                <div className="form-register_input">
                                    <DatePicker onChange={dob => this.setState({dob})}/>
                                </div>
                            </div>
                            <div className="form-register_question justifycentre">
                                <input type="submit" value="Reset" className="button"/>
                            </div>
                        </form>
                    )}
                </fieldset>
            </div>
        );
    }
}

ForgotPassword.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

export default connect(
    state => ({}),
    dispatch => ({dispatch}),
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Pages/ForgotPassword.jsx